var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 82,
    viewBox: "0 0 81 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 81.0845C34.875 81.0845 29.6055 80.015 24.6915 77.876C19.7775 75.737 15.5025 72.851 11.8665 69.218C8.2305 65.579 5.3445 61.304 3.2085 56.393C1.0725 51.482 0.003 46.2125 0 40.5845C0 34.9595 1.0695 29.69 3.2085 24.776C5.3475 19.862 8.2335 15.587 11.8665 11.951C15.5055 8.31497 19.7805 5.42897 24.6915 3.29297C29.6025 1.15697 34.872 0.0874727 40.5 0.0844727C46.65 0.0844727 52.482 1.39697 57.996 4.02197C63.51 6.64697 68.178 10.3595 72 15.1595V4.58447H81V31.5845H54V22.5845H66.375C63.3 18.3845 59.5125 15.0845 55.0125 12.6845C50.5125 10.2845 45.675 9.08447 40.5 9.08447C31.725 9.08447 24.2805 12.1415 18.1665 18.2555C12.0525 24.3695 8.997 31.8125 9 40.5845C9 49.3595 12.057 56.804 18.171 62.918C24.285 69.032 31.728 72.0875 40.5 72.0845C48.375 72.0845 55.257 69.5345 61.146 64.4345C67.035 59.3345 70.503 52.8845 71.55 45.0845H80.775C79.65 55.3595 75.2445 63.929 67.5585 70.793C59.8725 77.657 50.853 81.0875 40.5 81.0845ZM53.1 59.4845L36 42.3845V18.0845H45V38.7845L59.4 53.1845L53.1 59.4845Z",
    fill: "url(#paint0_linear_1_166)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_166",
    x1: -19.1613,
    y1: 81.0845,
    x2: 178.766,
    y2: 81.0845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3333FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.bfcdcf261444b00e5a300f8ee9bb1ff3.svg";
export { ForwardRef as ReactComponent };